export default [
  {
    Icono: "calendar_today",
    Modulo: "Pacientes",
    ModuloID: 1,
    Router: "/nutricion/pacientes",
  },
];
